import { isNonEmptyArray } from '@/helpers/array-helpers'
import TimesheetsPendingApprovalViewModel from './timesheetsPendingApprovalViewModel'

export default class TimesheetsViewModel {
  constructor({
    approvedCount = 0,
    pendingReviewCount = 0,
    pendingApprovalList = [],
  } = {}) {
    /**
     * @type {Number}
     */
    this.approvedCount = approvedCount

    /**
     * @type {Number}
     */
    this.pendingReviewCount = pendingReviewCount

    /**
     * @type {Array<TimesheetsPendingApprovalViewModel>}
     */
    this.pendingApprovalList = isNonEmptyArray(pendingApprovalList)
      ? pendingApprovalList.map(
          (pendingApproval) =>
            new TimesheetsPendingApprovalViewModel(pendingApproval)
        )
      : []
  }
}
